import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M6.5 16.45c0 2.083 2.339 3.182 4.015 2.156l7.262-4.45a2.51 2.51 0 0 0 0-4.311l-7.262-4.45C8.839 4.368 6.5 5.467 6.5 7.55z"
    />
  </svg>
);
export const PlayIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
